import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../constants/endpoints';
import { InfusionsViewerParams } from '../controllers/adep/infusion-viewer/infusions-viewer-params';
import TimelineContext from '../controllers/adep/services/timeline-service';
import { FoundationUtils } from './foundation-utils';
import { ADEP_E9129Parameters } from './parameters';

interface InfusionCheckingState {
  changeVial: string;
  realizeFirstChecking: boolean;
  realizeSecondChecking: boolean;
  utilizeFirstChecking: boolean;
}

export class InfusionSolutionsUtils {
  static shouldShowStartSolution(itemStatus: string, status: string): boolean {
    const tasyFunc9129 = 'ADEP#9129';
    const param13 = FoundationUtils.findModuleParam(tasyFunc9129, ADEP_E9129Parameters.ALLOWS_TO_PERFORM_PRESCRIPTION_ITEMS);
    const isParam13Valid = param13 === 'S' || param13 === 'D';
    const isItemStatusValid = itemStatus === 'N';
    const isStatusValid = status === 'PENDING';
    const { stepSolutionNumber, isPdo } = InfusionsViewerParams.infusionDetailsParams;
    const isStatusSolutionValid = isPdo === 'N' || stepSolutionNumber === 1;

    return isParam13Valid && isItemStatusValid && isStatusValid && isStatusSolutionValid;
  }

  static shouldShowRestartSolution(itemStatus: string, status: string): boolean {
    const { stepSolutionNumber } = InfusionsViewerParams.infusionDetailsParams;
    const isItemStatusValid = ['INT', 'II'].some(st => st === itemStatus);
    const isStatusValid = ['PENDING', 'INTERRUPTED'].some(st => st === status);

    return isStatusValid && isItemStatusValid && stepSolutionNumber !== 1;
  }

  static shouldShowInterrupt(itemStatus: string, status: string): boolean {
    const isItemStatusValid = ['I', 'R'].some(st => st === itemStatus);
    const isStatusValid = status === 'STARTED';

    return isItemStatusValid && isStatusValid;
  }

  static getInfusionCheckingState(actionType: string): Promise<InfusionCheckingState> {
    const { solutionId, prescriptionId, isPdo } = InfusionsViewerParams.infusionDetailsParams;
    const { id } = TimelineContext.get();
    const params = {
      actionType,
      prescriptionNumber: prescriptionId,
      scheduleSequenceNumber: id,
      solutionSequence: solutionId,
      statusSolution: isPdo
    }

    return HttpService.get(Endpoint.EMAR_FIND_INFUSION_CHECKING_STATE, params).then(res => {
      const body = res.body as InfusionCheckingState;
      return body;
    });
  }
}
